import { Crisp } from "crisp-sdk-web";

export default defineNuxtPlugin(() => {
  return {
    provide: {
      crisp: Crisp,
    },
  };
});
